import { useDisclosure } from '@ritualco/jutsu'
import { useUpdateMerchantList } from 'api/endpoints/merchantLists'
import {
  EditableSection,
  EditableSectionTermRow,
  EditableSectionTerm,
  EditableSectionValue,
} from 'components/EditableSection'
import { MerchantListEditModal } from 'components/Modals/MerchantListEditModal'
import { useContent } from 'lib/content/react'
import type { MerchantListType } from 'lib/generated/api'
import { ReactComponent as EditIcon } from '../../assets/Icons/Edit.svg'

type DetailsSectionProps = {
  organizationId: string
  workspaceId: string
  merchantListId: string
  name?: string
  type: MerchantListType
}

export const DetailsSection = (props: DetailsSectionProps) => {
  const { organizationId, workspaceId, merchantListId, name, type } = props
  const { isOpen, onOpen, onClose } = useDisclosure()
  const update = useUpdateMerchantList()
  const { formatMessage } = useContent()

  return (
    <>
      <EditableSection
        title={formatMessage({
          id: 'pmportal.restaurantLists.listDetailsTitle',
        })}
        onEditClick={onOpen}
        pt={3}
        icon={<EditIcon style={{ height: 18, width: 18 }} />}
      >
        <EditableSectionTermRow>
          <EditableSectionTerm>
            {formatMessage({ id: 'pmportal.restaurantLists.listName' })}
          </EditableSectionTerm>
          <EditableSectionValue>{name || '-'}</EditableSectionValue>
        </EditableSectionTermRow>
        <EditableSectionTermRow>
          <EditableSectionTerm>
            {formatMessage({ id: 'pmportal.restaurantLists.listId' })}
          </EditableSectionTerm>
          <EditableSectionValue isReadOnly>
            {merchantListId}
          </EditableSectionValue>
        </EditableSectionTermRow>
      </EditableSection>
      <MerchantListEditModal
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={({ name }) => {
          update.mutate({
            organizationId,
            workspaceId,
            merchantListId,
            merchantList: {
              name: name || '',
              type,
            },
          })
        }}
        listDetails={{
          id: merchantListId,
          name,
          type,
        }}
      />
    </>
  )
}
